import React, { useState, useEffect } from 'react';
import './gallery.scss';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSuppliersStart } from '../../redux/suppliers/slice';
import i18next from 'i18next';

const PLACEHOLDER_IMG = 'https://dummyimage.com/300x200/cccccc/000000&text=No+Image';

const getAltText = (img, t) => {
  if (i18next.language === 'he') {
    return img.alt || t('Office');
  }
  const fileNameWithoutExtension = img.file ? img.file.split('.').slice(0, -1).join('.') : '';
  return fileNameWithoutExtension || t('Office');
};

export const getCloudinaryUrl = (file, width, height) => {
  const baseUrl = 'https://res.cloudinary.com/paapmpaapm/image/fetch';
  const transformations = width && height ? `/c_fill,w_${width},h_${height}` : '';
  return `${baseUrl}${transformations}/${file}`;
};

const OfficeGallery = ({ locationName, t, locationCode }) => {
  const dispatch = useDispatch();
  const { data: suppliers, loading, error } = useSelector((state) => state.suppliers);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImg, setModalImg] = useState(null);

  useEffect(() => {
    if (!locationCode) return;
    dispatch(fetchSuppliersStart(locationCode));
  }, [locationCode, dispatch]);

  return (
    <>
      <div className="container py-5">
        <h2 className="display-6 fw-bold mb-4">{t('imagesCarRentalOffices', { location: locationName })}</h2>
        {loading ? (
          <div className="text-center py-5">{t('loading')}</div>
        ) : error ? (
          <div className="text-danger text-center py-5">{t('Error')}: {error}</div>
        ) : suppliers?.images?.length === 0 ? (
          <div className="text-center py-5">{t('No images found for this location.')}</div>
        ) : (
          <div className="office-gallery row g-3">
            {suppliers?.images?.slice(0, 12).map((img, idx) => (
              <div key={img.file || idx} className="col-12 col-sm-6 col-md-4 mb-3">
                <div
                  className="office-gallery-item"
                  onClick={() => {
                    setModalImg(`https://paapmpaapm.com/locations-guide/img/${img.file}` || PLACEHOLDER_IMG);
                    setModalOpen(true);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="office-gallery-img-wrapper" style={{ position: 'relative', width: '100%', height: '100%' }}>
                    <img
                      src={getCloudinaryUrl(`https://paapmpaapm.com/locations-guide/img/${img.file}`, 300, 200) || PLACEHOLDER_IMG}
                      alt={getAltText(img, t)}
                      className="office-gallery-img"
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = PLACEHOLDER_IMG;
                      }}
                    />
                  </div>
                  <div className="office-gallery-caption text-center mt-2">{getAltText(img, t) || t('Office')}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      {modalOpen && (
        <div className="office-gallery-modal" onClick={() => setModalOpen(false)}>
          <img src={modalImg} alt="Office Fullscreen" className="office-gallery-modal-img" />
        </div>
      )}
    </>
  );
};

export default OfficeGallery;
